export enum IconPosition {
  Start,
  End,
}
